import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GithubUserSelector } from './GithubUserSelector';

export const GithubUserSelectorFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubUserSelector',
    component: GithubUserSelector,
  }),
);
